<script>
import appConfig from "@/app.config";
import Swal from "sweetalert2";
//import Basic from "./basic";
import axios from "axios";

import {
  required,
  //email,
  //minLength,
  //sameAs,
  //maxLength,
  //minValue,
  //maxValue,
  //numeric,
  //url,
  //alphaNum
} from "vuelidate/lib/validators";

/**
 * Form validation component
 */
export default {
  page: {
    title: "Category Calibration",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {  },
  props:{
    idRecord: Number,
    idEntity: [String, Number, null],
    record:   [Object, null]
  },
  data() {
    return {
      info: null,
      componentKey: 0,
      submitted: false,
      title: "Category calibration registration",
      items: [
        {text: "Equipment",  href: "/"},
        {text: "Categories",   href: "/equipment/categories"},
        {text: "Calibration",    active: true}
      ],
      form: {
        id_category:                      "",
        id_timeFrecuency:                 "",
        de_timeFrecuency:                 "",
        de_calibrationActivity:           "",
        de_calibrationResponsible:        "",
        de_procedure:          "",
        de_calibrationRecord:             "",
        de_calibrationCorrectiveActions:  "",
      },
      frecuencies: [],
    };
  },
  validations: {
    form: {
      id_category:                      { required },
      id_timeFrecuency:                 { required },
      de_calibrationActivity:           { required },
      de_calibrationResponsible:        { required },
      de_procedure:          { required },
      de_calibrationRecord:             { required },
      de_calibrationCorrectiveActions:  { required },
    }
  },
  watch:{
    
  },
  created(){
    if( this.idRecord ){
      this.form.id_category                       = this.record.id_category;
      this.form.id_timeFrecuency                  = this.record.id_timeFrecuency;
      this.form.de_timeFrecuency                  = this.record.de_timeFrecuency;
      this.form.de_calibrationActivity            = this.record.de_calibrationActivity;
      this.form.de_calibrationResponsible         = this.record.de_calibrationResponsible;
      this.form.de_procedure           = this.record.de_procedure;
      this.form.de_calibrationRecord              = this.record.de_calibrationRecord;
      this.form.de_calibrationCorrectiveActions   = this.record.de_calibrationCorrectiveActions;
      this.form.id_calibration                    = this.record.id_calibration;
    }
  },
  mounted() {
    this.getFrecuencies();
  },
  methods: {
    logState(){
      let app = this;

      this.frecuencies.forEach(function(item){
        if(item.id_timeFrecuency == app.form.id_timeFrecuency){
          app.form.de_timeFrecuency = item.de_timeFrecuency;
        }
      });
    },

    emit(){
      Swal.close();
      this.$emit('success');
    },

    getFrecuencies(){
      let app = this;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/calibrations.php',
        {
          params: {
            request:      'getFrecuencies',
          }
        }
      )
      .then(response => {
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.frecuencies = response.data;
          }else{
            Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },


    // eslint-disable-next-line no-unused-vars
    saveCategoryCalibration(e) {
      let app = this;
      let successMessage = "";

      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if( this.idRecord ){
        this.form.id_calibration = this.idRecord;
      }

      if( this.idEntity ){
        this.form.id_category = this.idEntity;
      }

      if( !this.$v.form.$error ){

        Swal.fire({
          title: "Saving category calibration.",
          showConfirmButton:false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });

        axios.post(window.serverPath+'dist/mvw/controllers/calibrations.php', {
          request: 'saveCategoryCalibration',
          data: app.form, 
        })
        .then(function (response) {
          let action = "";

          if(response.status == 500){ app.$router.push({ name: 'Error-500' }); }
          if(response.status == 404){ app.$router.push({ name: 'Error-404' }); }
          if(response.status == 401){ app.$router.push({ name: 'Error-401' }); }
          
          if( response.data === "OK" ){
            action = "saved";
          }
          if( response.data === "UPDATED" ){
            action = "updated";
          }

          Swal.fire("Good job!", "The category calibration is correctly "+action+"!", "success");
          //app.$router.push({ name: 'industries' });



          if(response.data){
            Swal.fire(
              'Congrats!!!','<p><b>'+successMessage+'</b></p>',
              'success',
            ).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                //app.$router.push({ name: 'industries'});
                app.emit();
              }
            });
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        })
        .catch(function (error) {
          Swal.fire("Ooops!" + error.message, "Seems like some error ocurr, please try again.", "error");
        });
      }
    }
  }
};
</script>

<template>
    <form class="needs-validation" @submit.prevent="saveCategoryCalibration">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-md-12">
              <h4 class="card-title">{{title}}</h4>
              <p class="card-title-desc">Provide all information related to category calibration.</p>

              <div class="form-group">
                <label for="id_timeFrecuency">Frecuency</label>
                <select
                  class="form-control-sm"
                  :class="{ 'is-invalid': submitted && $v.form.id_timeFrecuency.$error }"
                  name="id_timeFrecuency"
                  id="id_timeFrecuency"
                  v-model="form.id_timeFrecuency"
                  @change="logState"
                >
                  <option value="">SELECT CALIBRATION FRECUENCY</option>
                  <option v-for="(frecuency, index) in frecuencies" :key="index" :value="frecuency.id_timeFrecuency">{{frecuency.de_timeFrecuency}}</option>
                </select>
                <div v-if="submitted && $v.form.id_timeFrecuency.$error" class="invalid-feedback">
                  <span v-if="!$v.form.id_timeFrecuency.required">Frecuency field is required.</span>
                </div>
              </div>

              <div class="form-group">
                <label for="de_calibrationActivity">Calibration activity</label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.de_calibrationActivity.$error }"
                  name="de_calibrationActivity"
                  id="de_calibrationActivity"
                  v-model="form.de_calibrationActivity"
                  value=""
                >
                <div v-if="submitted && $v.form.de_calibrationActivity.$error" class="invalid-feedback">
                  <span v-if="!$v.form.de_calibrationActivity.required">Calibration activity is required.</span>
                </div>
              </div>

              <div class="form-group">
                <label for="de_calibrationResponsible">Calibration responsible</label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.de_calibrationResponsible.$error }"
                  name="de_calibrationResponsible"
                  id="de_calibrationResponsible"
                  v-model="form.de_calibrationResponsible"
                  value=""
                >
                <div v-if="submitted && $v.form.de_calibrationResponsible.$error" class="invalid-feedback">
                  <span v-if="!$v.form.de_calibrationResponsible.required">Calibration responsible is required.</span>
                </div>
              </div>

              <div class="form-group">
                <label for="de_calibrationRecord">Calibration record(s)</label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.de_calibrationRecord.$error }"
                  name="de_calibrationRecord"
                  id="de_calibrationRecord"
                  v-model="form.de_calibrationRecord"
                  value=""
                >
                <div v-if="submitted && $v.form.de_calibrationRecord.$error" class="invalid-feedback">
                  <span v-if="!$v.form.de_calibrationRecord.required">Calibration record(s) is required.</span>
                </div>
              </div>

              <div class="form-group">
                <label for="de_procedure">Calibration procedure/description</label>
                <div class="form-group">
                  <textarea name="de_procedure" v-model="form.de_procedure" class="form-control"></textarea>
                  <div v-if="submitted && $v.form.de_procedure.$error" class="invalid-feedback">
                    <span v-if="!$v.form.de_procedure.required">Calibration procedure/description is required.</span>
                  </div>
                  <!--
                  <ckeditor type="classic" name="de_procedure" v-model="form.de_procedure" :class="{ 'is-invalid': submitted && $v.form.de_procedure.$error }"></ckeditor>
                  <div v-if="submitted && $v.form.de_procedure.$error" class="invalid-feedback">
                    <span v-if="!$v.form.de_procedure.required">Calibration procedure/description is required.</span>
                  </div>
                  -->
                </div>
              </div>

              <div class="form-group">
                <label for="de_calibrationCorrectiveActions">Corrective Actions</label>
                <div class="form-group">
                  <textarea name="de_calibrationCorrectiveActions" v-model="form.de_calibrationCorrectiveActions" class="form-control"></textarea>
                  <div v-if="submitted && $v.form.de_calibrationCorrectiveActions.$error" class="invalid-feedback">
                    <span v-if="!$v.form.de_calibrationCorrectiveActions.required">Corrective Actions are required.</span>
                  </div>
                  <!--
                  <ckeditor type="classic" name="de_calibrationCorrectiveActions" v-model="form.de_calibrationCorrectiveActions" :class="{ 'is-invalid': submitted && $v.form.de_calibrationCorrectiveActions.$error }"></ckeditor>
                  <div v-if="submitted && $v.form.de_calibrationCorrectiveActions.$error" class="invalid-feedback">
                    <span v-if="!$v.form.de_calibrationCorrectiveActions.required">Corrective Actions are required.</span>
                  </div>
                  -->
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12 mt-5">
              <div class="form-group text-center">
                <button class="btn btn-success mr-3" type="submit">SAVE CALIBRATION</button>
                <button class="btn btn-danger" @click="emit();" type="reset">CANCEL </button>
                <!--
                <router-link to="/management/products" class="ml-3">
                  <button class="btn btn-danger" type="reset">CANCEL </button>
                </router-link>
                -->
              </div>
            </div>
          </div>

        </div>
      </div>
    </form>
</template>

<style type="text/css">
  .form-control-sm{
    display: block;
    width: 100%;
    height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 0.5rem;
    font-size: 0.7875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #505d69;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.2rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
</style>